import { useEffect, useState } from "react";
import useApi from "./useApi";

interface AccelaConfig {
  id: number;
  agencyName: string;
  clientId: string;
  clientSecret: string;
  emailAddress: string;
  accessToken: string;
  refreshToken: string;
  scope?: string;
  teamId: number;
  token?: string;
}

export default function useAccelaConfigs(teamId: number) {
  const [items, setItems] = useState<AccelaConfig[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const api = useApi();

  useEffect(() => {
    async function fetchConfigs() {
      setLoading(true);
      const resp = await api.messaging.get(`Accela/Integrations/`);
      setItems(await resp.json());
      setLoading(false);
    }

    fetchConfigs();
  }, [api.messaging]);

  return { items, loading };
}
